module.exports = __webpack_public_path__ + "img/c-lifting-2.df4ed74b.jpg";